import type { EntityId } from '../shared'

export enum UserRoles {
  System = 'system',
  Admin = 'admin',
  Technician = 'technician',
  Pharmacist = 'pharmacist',
  Customer = 'customer',
  Patient = 'patient',
  LeadPharmacist = 'leadPharmacist',
  Tester = 'tester',
  CustomerSupport = 'customerSupport',
  LeadCustomerSupport = 'leadCustomerSupport',
  Warehouse = 'warehouse',
  LeadWarehouse = 'leadWarehouse',
  Developer = 'developer',
  Compliance = 'compliance',
  OtcOnly = 'otcOnly',
  LeadOtcOnly = 'leadOtcOnly',
}

export interface User {
  _id: EntityId
  locationId?: EntityId
  pioneerPharmacistId?: string
  firstName?: string
  lastName?: string
  preferredName?: string
  username?: string
  email?: string
  password?: string
  forcePasswordReset?: boolean
  temporaryId?: EntityId
  temporaryPassword?: string
  roles: string[]
  system: 'Pharmacy'
  disabled: boolean
  lastInviteSentAt?: Date
  invitesSentCount?: number
  lastCheckedReleaseNotes?: string
}

export const nonCSARoles = [
  UserRoles.System,
  UserRoles.Admin,
  UserRoles.Technician,
  UserRoles.Pharmacist,
  UserRoles.Customer,
  UserRoles.Patient,
  UserRoles.LeadPharmacist,
  UserRoles.Tester,
  UserRoles.Warehouse,
  UserRoles.LeadWarehouse,
  UserRoles.Developer,
  UserRoles.Compliance,
  UserRoles.OtcOnly,
  UserRoles.LeadOtcOnly,
]

export const allRolesExceptCustomerSupport = [...nonCSARoles, UserRoles.LeadCustomerSupport]
export const otcOnlyRoles = [UserRoles.OtcOnly, UserRoles.LeadOtcOnly]
export const prescriberManagementRoles = [
  UserRoles.Admin,
  UserRoles.LeadCustomerSupport,
  UserRoles.LeadPharmacist,
  UserRoles.Technician,
]
export const bulkActionRoles = [
  UserRoles.Admin,
  UserRoles.LeadPharmacist,
  UserRoles.Pharmacist,
  UserRoles.LeadCustomerSupport,
  UserRoles.LeadWarehouse,
  UserRoles.OtcOnly,
  UserRoles.LeadOtcOnly,
]
export const splitOrderRoles = [
  UserRoles.Admin,
  UserRoles.LeadPharmacist,
  UserRoles.LeadCustomerSupport,
  UserRoles.LeadWarehouse,
]
export interface License {
  id: string
  number: string
  expirationDate: Date
  registeredState: string
  imageId?: string
}
